import * as types from "../types";
import { apolloClient } from "@/plugins/apollo";
import {
    GREENHOUSE_DEPARTMENT_SECTIONS_QUERY,
    SINGLE_GREENHOUSE_DEPARTMENT_SECTION_QUERY,
    CREATE_GREENHOUSE_DEPARTMENT_SECTION_MUTATION,
    UPDATE_GREENHOUSE_DEPARTMENT_SECTION_MUTATION,
    DELETE_GREENHOUSE_DEPARTMENT_SECTION_MUTATION
} from "@/graphql/greenhouseDepartmentSections.js";

const state = {
    greenhouseDepartmentSections: []
};

const getters = {};

const mutations = {
    [types.SET_GREENHOUSE_DEPARTMENT_SECTIONS](
        state,
        greenhouseDepartmentSections
    ) {
        state.greenhouseDepartmentSections = greenhouseDepartmentSections;
    },
    [types.SORT_GREENHOUSE_DEPARTMENT_SECTIONS](state) {
        state.greenhouseDepartmentSections.sort(function(a, b) {
            // first sort by greenhouse name, then sort by department name, then by section name
            if (
                a.node.greenhouseDepartment.greenhouse.id ==
                b.node.greenhouseDepartment.greenhouse.id
            ) {
                if (
                    a.node.greenhouseDepartment.id ==
                    b.node.greenhouseDepartment.id
                ) {
                    return a.node.name.toLowerCase() ==
                        b.node.name.toLowerCase()
                        ? 0
                        : a.node.name.toLowerCase() > b.node.name.toLowerCase()
                        ? 1
                        : -1;
                } else {
                    return a.node.greenhouseDepartment.name.toLowerCase() ==
                        b.node.greenhouseDepartment.name.toLowerCase()
                        ? 0
                        : a.node.greenhouseDepartment.name.toLowerCase() >
                          b.node.greenhouseDepartment.name.toLowerCase()
                        ? 1
                        : -1;
                }
            } else {
                return a.node.greenhouseDepartment.greenhouse.name.toLowerCase() ==
                    b.node.greenhouseDepartment.greenhouse.name.toLowerCase()
                    ? 0
                    : a.node.greenhouseDepartment.greenhouse.name.toLowerCase() >
                      b.node.greenhouseDepartment.greenhouse.name.toLowerCase()
                    ? 1
                    : -1;
            }
        });
    },
    [types.UPSERT_GREENHOUSE_DEPARTMENT_SECTION](
        state,
        greenhouseDepartmentSection
    ) {
        var index = state.greenhouseDepartmentSections.findIndex(function(
            element
        ) {
            return element.node.id == greenhouseDepartmentSection.id;
        });

        const node = { node: greenhouseDepartmentSection };

        if (index > -1) {
            state.greenhouseDepartmentSections.splice(index, 1, node);
        } else {
            state.greenhouseDepartmentSections.unshift(node);
        }
    },
    [types.DELETE_GREENHOUSE_DEPARTMENT_SECTION](
        state,
        greenhouseDepartmentSection
    ) {
        var index = state.greenhouseDepartmentSections.find(function(
            element,
            index
        ) {
            if (element.id == greenhouseDepartmentSection.id) {
                return index;
            }
        });

        if (index > -1) {
            state.greenhouseDepartmentSections.splice(index, 1);
        }
    }
};

const actions = {
    async fetchGreenhouseDepartmentSections(context) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: GREENHOUSE_DEPARTMENT_SECTIONS_QUERY,
                    fetchPolicy: "network-only"
                })
                .then(response => {
                    // console.log(response);

                    // Option 1: if need extra calculate for each node, use this option
                    // const greenhouseDepartmentSections = response.data.greenhouseDepartmentSections.edges.map(
                    //     item => {
                    //         return {
                    //             node: item.node
                    //         };
                    //     }
                    // );

                    // Option 2
                    const greenhouseDepartmentSections =
                        response.data.greenhouseDepartmentSections.edges;

                    // set
                    context.commit(
                        types.SET_GREENHOUSE_DEPARTMENT_SECTIONS,
                        greenhouseDepartmentSections
                    );

                    // sort
                    context.commit(types.SORT_GREENHOUSE_DEPARTMENT_SECTIONS);

                    resolve(greenhouseDepartmentSections);
                })
                .catch(error => {
                    console.log(error);
                    reject(error);
                });
        });
    },

    async fetchSingleGreenhouseDepartmentSection(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: SINGLE_GREENHOUSE_DEPARTMENT_SECTION_QUERY,
                    fetchPolicy: "network-only",
                    variables: {
                        id: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const greenhouseDepartmentSection = JSON.parse(
                        JSON.stringify(
                            response.data.greenhouseDepartmentSection
                        )
                    );

                    // update store
                    context.commit(
                        types.UPSERT_GREENHOUSE_DEPARTMENT_SECTION,
                        greenhouseDepartmentSection
                    );

                    // sort
                    context.commit(types.SORT_GREENHOUSE_DEPARTMENT_SECTIONS);

                    resolve(greenhouseDepartmentSection);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async createGreenhouseDepartmentSection(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CREATE_GREENHOUSE_DEPARTMENT_SECTION_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const greenhouseDepartmentSection =
                        response.data.createGreenhouseDepartmentSection
                            .greenhouseDepartmentSection;

                    // update store
                    context.commit(
                        types.UPSERT_GREENHOUSE_DEPARTMENT_SECTION,
                        greenhouseDepartmentSection
                    );

                    // sort
                    context.commit(types.SORT_GREENHOUSE_DEPARTMENT_SECTIONS);

                    resolve(greenhouseDepartmentSection);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async updateGreenhouseDepartmentSection(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UPDATE_GREENHOUSE_DEPARTMENT_SECTION_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const greenhouseDepartmentSection =
                        response.data.updateGreenhouseDepartmentSection
                            .greenhouseDepartmentSection;

                    // update store
                    context.commit(
                        types.UPSERT_GREENHOUSE_DEPARTMENT_SECTION,
                        greenhouseDepartmentSection
                    );

                    // sort
                    context.commit(types.SORT_GREENHOUSE_DEPARTMENT_SECTIONS);

                    resolve(greenhouseDepartmentSection);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async deleteGreenhouseDepartmentSection(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DELETE_GREENHOUSE_DEPARTMENT_SECTION_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    // console.log(response);

                    const greenhouseDepartmentSection =
                        response.data.deleteGreenhouseDepartmentSection
                            .greenhouseDepartmentSection;

                    // delete
                    context.commit(
                        types.DELETE_GREENHOUSE_DEPARTMENT_SECTION,
                        greenhouseDepartmentSection
                    );

                    resolve(greenhouseDepartmentSection);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
